/**
 * This Javascript is responsible of rendering domain connection modal dialog
 */
(function() {
    var n = diy.editor.notifications;
    n.api.ready(function() {
        var nodomainNotifications = n.api.getNotificationsByType(n.Notifications.TYPE_NO_DOMAIN);
        if (jimdoData.features.domainConnected
            || !jimdoData.notificationData.noDomain.show) {

            if (nodomainNotifications.length > 0) {
                n.api.deleteNotificationByType(n.Notifications.TYPE_NO_DOMAIN);
            }
        } else {
            if (!jimdoData.notificationData.noDomain.triggerShow) {
                return;
            }

            if (nodomainNotifications.length > 0) {
                n.api.updateNotification(nodomainNotifications[0].getId(), { dismissed: 0 });
            } else {
                n.api.createNotification({type: n.Notifications.TYPE_NO_DOMAIN});
            }
        }
    });
}());



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/toolbar/notification/nodomainnotification.js
 ** module id = 673
 ** module chunks = 0
 **/